import axios from 'axios';
import config from './config';
import router from '@/router'
import md5 from 'js-md5'
import qs from 'qs'
import store from '../store'
import { MessageBox, Message } from 'element-ui'
export default function $axios(options) {
  let now = Date.now();
  const paramsSort = (obj) => {
    let newkey = Object.keys(obj).sort();
    let newObj = {};
    for (let i = 0; i < newkey.length; i++) {
      newObj[newkey[i]] = obj[newkey[i]];
    }
    return newObj;
  }

  const form = (data)=>{
    let url = window.location.href;
    let domain = url.split(".")[0];
    let code = domain.split("//")[1];
    let packetParam = {
      recData: data === undefined ? {} : paramsSort(data),
      reqTime: now,
      token: store.state.token || '',
      versionNo: '1.0.0',
      websiteCode: 7895
    }
    let resultParam = {
      packet: JSON.stringify(packetParam),
      sign: md5(JSON.stringify(packetParam) + 'fda566196eb14cc2bc246f00a72913f7')
    }
    return resultParam;
  }

  return new Promise((resolve, reject) => {

    const instance = axios.create({
      baseURL: config.baseUrl,
      headers: config.headers,
      timeout: config.timeout,
      withCredentials: config.withCredentials
    })
    // request 请求拦截器
    instance.interceptors.request.use(
      config => {
        if (config.method === 'post') {
          config.data = qs.stringify(form(config.data))
        }else if(config.method === 'get') {
          config.params = form(config.params)
        }
        // let token = Cookies.get('token')
        // if (token) {
        //   config.headers.token = token
        // } else {
        //   router.push('/').catch(data => {  })
        // }
        return config
      },
      error => {
        // 请求发生错误时
        console.log('request:', error)
        // 判断请求超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
          console.log('timeout请求超时')
        }
        //登录验证失效

        // if (error.code === )
        // 需要重定向到错误页面
        const errorInfo = error.response
        console.log(errorInfo)
        if (errorInfo) {
          error = errorInfo.data  // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status; // 404 403 500 ...
          router.push({
            path: `/error/${errorStatus}`
          }).catch(data => {  })
        }
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )
    // response 响应拦截器
    instance.interceptors.response.use(
      response => {
        if (response.data.rstCode == '000') {
          return response.data
        } else if (response.data.rstCode.length == 4) {
          // this.$message.error(response.data.rstMsg);
          Message({
            message: response.data.rstMsg,
            type: 'error',
            duration: 5 * 1000
          })
        } else if (response.data.rstCode.length == 5) {
          Message({
            message: response.data.rstMsg,
            type: 'error',
            duration: 5 * 1000
          })
        }
        return 'error'
      },
      err => {
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break
            case 401:
              err.message = '未授权，请登录'
              break
            case 403:
              err.message = '拒绝访问'
              break
            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`
              break
            case 408:
              err.message = '请求超时'
              break
            case 500:
              err.message = '服务器内部错误'
              break
            case 501:
              err.message = '服务未实现'
              break
            case 502:
              err.message = '网关错误'
              break
            case 503:
              err.message = '服务不可用'
              break
            case 504:
              err.message = '网关超时'
              break
            case 505:
              err.message = 'HTTP版本不受支持'
              break
            default:
          }
        }
        console.error('error:'+err)
        Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(err) // 返回接口返回的错误信息
      }
    )
    // 请求处理
    instance(options).then(res => {
      resolve(res)
      return false
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/axios.js